export const GET_ALL_BLACKLIST_REQUEST = 'GET_ALL_BLACKLIST_REQUEST';
export const GET_ALL_BLACKLIST_SUCCESS = 'GET_ALL_BLACKLIST_SUCCESS';
export const GET_ALL_BLACKLIST_FAILURE = 'GET_ALL_BLACKLIST_FAILURE';

export const GET_BLACKLIST_BY_ID_REQUEST = 'GET_BLACKLIST_BY_ID_REQUEST';
export const GET_BLACKLIST_BY_ID_SUCCESS = 'GET_BLACKLIST_BY_ID_SUCCESS';
export const GET_BLACKLIST_BY_ID_FAILURE = 'GET_BLACKLIST_BY_ID_FAILURE';

export const UPDATE_BLACKLIST_REQUEST = 'UPDATE_BLACKLIST_REQUEST';
export const UPDATE_BLACKLIST_SUCCESS = 'UPDATE_BLACKLIST_SUCCESS';
export const UPDATE_BLACKLIST_FAILURE = 'UPDATE_BLACKLIST_FAILURE';

export const UPDATE_BLACKLIST_STATUS_REQUEST = 'UPDATE_BLACKLIST_STATUS_REQUEST';
export const UPDATE_BLACKLIST_STATUS_SUCCESS = 'UPDATE_BLACKLIST_STATUS_SUCCESS';
export const UPDATE_BLACKLIST_STATUS_FAILURE = 'UPDATE_BLACKLIST_STATUS_FAILURE';

export const ADD_BLACKLIST_REQUEST = 'ADD_BLACKLIST_REQUEST';
export const ADD_BLACKLIST_SUCCESS = 'ADD_BLACKLIST_SUCCESS';
export const ADD_BLACKLIST_FAILURE = 'ADD_BLACKLIST_FAILURE';
